import { PrototypeProvider, usePrototype } from './PrototypeContext'
import HomeScreen from './HomeScreen'
import HiveEditor from './HiveEditor'
import WarScreen from './WarScreen'
import TutorialScreen from './TutorialScreen'
import WarMenu from './WarMenu'
import WaitingRoom from './WaitingRoom'
import WarHistory from './WarHistory'
import './prototype.css'

// The progression prototype, for a signed-in player: home, their Hive, the
// war menu, a challenge's waiting room, war history, a war.
export default function PrototypeApp() {
    return (
        <PrototypeProvider>
            <Screens />
        </PrototypeProvider>
    )
}

function Screens() {
    const { screen } = usePrototype()
    if (screen.name === 'tutorial') return <TutorialScreen />
    if (screen.name === 'hive') return <HiveEditor />
    if (screen.name === 'warMenu') return <WarMenu />
    if (screen.name === 'waiting') return <WaitingRoom />
    if (screen.name === 'history') return <WarHistory />
    if (screen.name === 'war') return <WarScreen key={screen.warId} warId={screen.warId} />
    return <HomeScreen />
}
